<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from 'vue';

import {
} from '@/modules/core/components';

import {
    MainContainer,
    FabricCanvas,
} from './components';
import { useBreakpoints, breakpointsBootstrapV5 } from '@vueuse/core';
import { setCssHelperVars } from '@/modules/core/utilities';

export default defineComponent({
    components: {
        MainContainer,
        FabricCanvas,
    },
    setup() {
        const breakpoints = useBreakpoints(breakpointsBootstrapV5);
        const lgAndGreater = breakpoints.greater('lg');

        const unmuteBgMusic = () => {
            const audio = document.getElementById('bg-music') as HTMLAudioElement | null;
            if (audio) {
                audio.muted = false;
                audio.play().catch(() => {});
            }
        };

        onMounted(() => {
            setCssHelperVars();

            // Audio starts muted (allowed by browsers), unmute on first interaction
            document.addEventListener('click', unmuteBgMusic, { once: true });
            document.addEventListener('touchstart', unmuteBgMusic, { once: true });
        });

        onUnmounted(() => {
            document.removeEventListener('click', unmuteBgMusic);
            document.removeEventListener('touchstart', unmuteBgMusic);
        });

        return {
            lgAndGreater
        }
    }
})
</script>